import { Injectable, inject } from '@angular/core';
import { take } from 'rxjs';

import { JsToNgService } from '@ng2/services/js-to-ng.service';
import { DictionaryStore } from '@signal-store/dictionary.store';
import { TenantStore } from '@signal-store/tenant.store';
import { UserStore } from '@signal-store/user.store';
import { ContextInfo } from '@system/context';

@Injectable({
  providedIn: 'root',
})
export class BridgeService {
  private userStore = inject(UserStore);
  private jsToNgService = inject(JsToNgService);
  private tenantStore = inject(TenantStore);
  private dictionaryStore = inject(DictionaryStore);

  constructor() {
    this.jsToNgService.context.subscribe(context => {
      if (
        !context ||
        this.getEntityInstanceId(this.userStore.userData().context) === this.getEntityInstanceId(context)
      ) {
        return;
      }
      this.userStore.updateContext(context);
    });

    this.jsToNgService.refreshFromJsData.subscribe(refreshObj => {
      const { context, menu, tenants, user, emailCount } = refreshObj || {};
      if (context) {
        this.userStore.setReloadContext(true);
      }
      if (user) {
        this.userStore.refreshUserData();
      }
      if (tenants) {
        this.tenantStore.loadTenants().pipe(take(1)).subscribe();
      }
      if (menu) {
        this.userStore.reloadMenu();
      }
      if (emailCount) {
        this.userStore.refreshUnreadNotifications();
      }
    });

    this.jsToNgService.closedModalData.subscribe(data => this.userStore.closeJsDialog(data));

    this.jsToNgService.invalidateList.subscribe(listName => this.dictionaryStore.clearList(listName));
  }

  private getEntityInstanceId(context: ContextInfo): number {
    return (
      context?.contract?.entityInstanceId ?? context?.project?.entityInstanceId ?? context?.program?.entityInstanceId
    );
  }
}
